import React from "react";
import { TextField, IconButton } from "@livingdesign/react";

function TextInputField({
  value,
  handleChange,
  field,
  id,
  componentKey,
  ...props
}) {

  return (
    <>
      <TextField
        key={componentKey}
        disabled={field?.disabled}
        label={field?.label}
        leadingIcon={field?.leadingIcon || undefined}
        onChange={(event) => {
          handleChange(event.target.value);
        }}
        size={field?.size || "small"}
        trailing={
          field?.trailingIcon ? (
            <IconButton a11yLabel={field.trailingIconLabel}>{field.trailingIcon}</IconButton>
          ) : undefined
        }
        type={field?.type || "text"}
        value={value}
        name={`${id}-TextField`}
        textFieldProps={{
          ...field.inputProps
        }}
        UNSAFE_className={field?.className || ""}
        UNSAFE_style={field?.style || {}}
      />
    </>
  );
}

export default TextInputField;
